import {injectable} from "inversify";
import {Team} from "@/modules/team/entity";
import {Match} from "@/modules/match/entity";
import {LineupValidationType} from "@/modules/team/types";

@injectable()
export default class LineupValidator {
  async validate(team: Team, nextMatch?: Match): Promise<LineupValidationType> {
    if (!nextMatch) {
      return {
        type: 'success',
      };
    }

    if (this.hasSuspensions(team, nextMatch)) {
      return {
        type: 'error',
        message: translator.t('suspended_players_linedup'),
      };
    }

    const linedupCount = team.players.filter(p => p.lineup !== null).length;

    if (linedupCount < 7) {
      return {
        type: 'warning',
        message: translator.t('lineup_need_to_have_at_laest_x_players', {x: 7}),
      };
    }

    if (linedupCount < 11) {
      return {
        type: 'warning',
        message: translator.t('you_have_less_then_x_amount_of_players_linedup', {x: 11}),
      };
    }

    return {
      type: 'success',
    };
  }

  async isValid(team: Team, nextMatch?: Match) {
    if (!nextMatch) {
      return true;
    }

    return !this.hasSuspensions(team, nextMatch);
  }

  // todo remove if not needed
  private isFullLineup(team: Team): boolean {
    return team.players.filter(p => p.lineup !== null).length === 11;
  }

  private hasSuspensions(team: Team, nextMatch: Match): boolean {
    return !!team
      .players
      .filter(p => p.lineup !== null)
      .find(
        p => (p.suspensions ?? []).find(s => s.competitionId === nextMatch!.matchday.division.competitionId)
      );
  }
}
